import { MatMenuModule } from '@angular/material/menu';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LanguageModule } from '../language/language.module';
import { RouterModule } from '@angular/router';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import { MatDividerModule } from '@angular/material/divider';
import { MatIconModule } from '@angular/material/icon';
import { MatSelectModule } from '@angular/material/select';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatToolbarModule } from '@angular/material/toolbar';
import { CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { TranslationModule } from '../translation/translation.module';
import { FooterModule } from '../footer/footer.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { FilterModule } from '../filter/filter.module';
import { AddcolleagueComponent } from './addcolleague/addcolleague.component';
import { ColleaguesComponent } from './colleagues.component';
import { DeleteColleaguepopupComponent } from './delete-colleaguepopup/delete-colleaguepopup.component';



@NgModule({
  declarations: [AddcolleagueComponent,ColleaguesComponent, DeleteColleaguepopupComponent],
  exports: [AddcolleagueComponent,ColleaguesComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  imports: [
      CommonModule,
      LanguageModule,
      RouterModule,
      TranslationModule,
      MatToolbarModule,
      MatButtonModule,
      MatSidenavModule,
      MatIconModule,
      MatDividerModule,
      MatDialogModule,
      MatSelectModule,
      MatMenuModule,
      MatButtonModule,
      MatMenuModule,
      FooterModule,
      FormsModule,
      MatCheckboxModule,
      ReactiveFormsModule,
      FilterModule
  ]
})
export class ColleauguesModule { }
